import React from 'react';
import styles from './imageSelector.module.scss';
import ClassNames from 'classnames';
import SignedUrl from '../signedUrl';

interface IThumbnail {
  src: string;
  isSelected?: boolean;
  onSelect?: React.MouseEventHandler<HTMLElement>;
  onPreview?: React.MouseEventHandler<HTMLElement>;
}

const Thumbnail: React.FC<IThumbnail> = ({
  src,
  isSelected = false,
  onSelect,
  onPreview,
}) => {
  return (
    <div className={styles.thumbnail}>
      <SignedUrl>
        <img
          src={src}
          className={styles.image}
          onClick={onPreview}
          alt={'thumbnail img'}
        />
      </SignedUrl>
      <div
        onClick={onSelect}
        className={ClassNames(styles.radio, {
          [styles.selected]: isSelected,
        })}
      />
    </div>
  );
};

export default Thumbnail;
